<template>
  <div>
    <content-loader
      class="currently-video-placeholder"
      primary-color="#DEB1FD"
      secondary-color="#cccccc"
      :primary-opacity="0.6"
      :secondary-opacity="0.5"
      width="1184"
      height="666"
    >
      <rect x="0" y="0" width="1184" height="666" />
    </content-loader>
  </div>
</template>

<script setup lang="ts">
import { ContentLoader } from "vue-content-loader";

defineOptions({
  name: "currently-on-ersties-video-placeholder",
});
</script>

<style lang="scss">
@import "./index";
</style>
